import GenericTable from '../../../../../cars/components/V3/_shared/GenericTable/GenericTable'
import { TableMobileCardContent } from '../../../../../cars/components/V3/_shared/GenericTable/TableMobileCardContent'
import { useUserContext } from '../../../../../../context/UserProvider'
import { formatCurrency } from '../../../utils/formatCurrency'
import { useNavigate } from 'react-router-dom'
import tollReportTableColumns from './tollReportColumns'
import type { Toll } from '../../../../../../types'
import type { Row } from '@tanstack/react-table'
import { formatNumber } from '../../../utils/formatNumber'

type TollReportTableProps = {
  data: any
  isLoading?: boolean
}

function TollReportTable({ data, isLoading }: TollReportTableProps) {
  // @ts-ignore  remove this ts-ignore when UserContext is type safe
  const { chosenCompany, handleSetConsolidateInvoice } = useUserContext()
  const columns = tollReportTableColumns({ chosenCompany, handleSetConsolidateInvoice })

  return (
    <GenericTable
      className="max-h-[50vh]"
      data={data}
      isLoading={isLoading}
      columns={columns}
      mobileCardContent={(row) => {
        return <MobileCardContent row={row} handleSetConsolidateInvoice={handleSetConsolidateInvoice} />
      }}
    />
  )
}

export default TollReportTable

function MobileCardContent({
  row,
  handleSetConsolidateInvoice,
}: {
  row: Row<Toll>
  handleSetConsolidateInvoice: (value: string) => void
}) {
  const navigate = useNavigate()

  const header = `${row.original.tYear} - ${row.original.tMonth}`
  const data = [
    {
      label: 'Samlefakturakode',
      value: row.original.consolidatedInvoiceAgreement,
    },
    {
      label: 'Beløp',
      value: formatCurrency(row.original.amountIncVAT),
    },
    {
      label: 'Antall passeringer',
      value: formatNumber(row.original.antallPasseringer),
    },
  ]

  const action = {
    onClick: () => {
      handleSetConsolidateInvoice(row.original.consolidatedInvoiceAgreement)
      navigate(`/reports/toll/${row.original.tYear}-${row.original.tMonth}`)
    },
  }

  return <TableMobileCardContent header={header} data={data} action={action} />
}
